<header class="flex justify-between p-4">
  <div class="flex items-center">
    <div class="mr-4 flex items-center lg:hidden">
      <button
        type="button"
        class="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500"
        (click)="onToggleSidebar(true)"
      >
        <fa-icon [icon]="['fas', 'bars']" [size]="'2xl'"></fa-icon>
      </button>
      <tui-drawer
        class="[&&]:top-0 [&&]:h-full [&&]:w-64 [&&]:rounded-none"
        *tuiPopup="sidedarOpen()"
        direction="left"
        [overlay]="true"
        (click.self)="onToggleSidebar(false)"
      >
        <app-sidebar class="h-full w-64" [navItems]="navItems"> </app-sidebar>
      </tui-drawer>
    </div>
    <!-- Icon -->
    <a
      href="/"
      class="cursor-pointer"
      data-umami-event="landing-header-logo-click"
    >
      <div class="flex cursor-pointer items-center">
        <img
          class="mr-3 h-11 w-auto rounded-lg"
          [src]="'/assets/logo.svg'"
          alt="Logo"
        />
        <span class="text-xl font-bold text-black md:text-2xl"
          >Capawesome Cloud</span
        >
      </div>
    </a>
  </div>
  <!-- Navigation -->
  <nav class="hidden lg:block">
    <ul class="flex space-x-4">
      @for (item of navItems; track item.label) {
        <li>
          @if (item.items) {
            <button
              appearance="flat-grayscale"
              size="m"
              tuiButton
              tuiChevron
              tuiDropdownHover
              type="button"
              [tuiDropdown]="dropdownContent"
              [tuiDropdownOpen]="dropdownsOpen"
            >
              {{ item.label }}
              <ng-template #dropdownContent>
                <tui-data-list (click)="onDropdownItemClick()">
                  @for (subItem of item.items; track subItem.href) {
                    <a
                      tuiOption
                      [href]="subItem.href"
                      [target]="subItem.target"
                      class="!justify-start gap-3"
                    >
                      <tui-icon [icon]="subItem.icon"></tui-icon>
                      <div class="flex flex-col">
                        <span class="font-semibold text-gray-900">{{
                          subItem.label
                        }}</span>
                        <span class="text-sm text-gray-500">{{
                          subItem.description
                        }}</span>
                      </div>
                    </a>
                  }
                </tui-data-list>
              </ng-template>
            </button>
          } @else {
            <a
              appearance="flat-grayscale"
              size="m"
              tuiButton
              [target]="item.target"
              type="button"
              href="{{ item.href }}"
            >
              {{ item.label }}</a
            >
          }
        </li>
      }
    </ul>
  </nav>
  <!-- Buttons -->
  <div class="flex space-x-4">
    <div class="hidden sm:block">
      <a
        appearance="secondary"
        size="m"
        tuiButton
        type="button"
        [href]="bookingUrl"
        target="_blank"
        data-umami-event="landing-header-booking-demo-button"
        id="of-get-a-demo-header"
      >
        Book a demo
      </a>
    </div>
    <a
      size="m"
      tuiButton
      type="button"
      [href]="consoleBaseUrl"
      target="_blank"
      data-umami-event="landing-header-login-button"
    >
      Login
    </a>
  </div>
</header>
